module.exports = __webpack_public_path__ + "media/images/projet-labfilms-83f4bca296ffcef5d940884d3b7ba2a3.png";